import styled from 'styled-components';
import { Grid } from '@mui/material';

export const FormFieldsContainer = styled(({ children, ...props }) => (
  <Grid {...props} container spacing={2} direction="column">
    {children}
  </Grid>
))`
  && {
    display: flex;
    flex-direction: column;
    height: auto;
    margin: 0;

    justify-content: space-between;
    overflow: scroll;
    width: 430px;

    .MuiGrid-item {
      padding: 0;
    }
    .MuiOutlinedInput-root {
      height: 40px;
    }
    .preloader {
      height: 250px;
      display: grid;
      place-items: center;
    }
  }
`;
